import { AbstractControl, UntypedFormControl, ValidationErrors } from '@angular/forms';
import { PhoneNumberUtil } from 'google-libphonenumber';

export function phoneValidator(control: AbstractControl): ValidationErrors | null {
    const phoneNumberUtil = PhoneNumberUtil.getInstance();
    const number = control.value;

    if (!number) return null;

    try {
        const phoneNumber = phoneNumberUtil.parse(number);
        const isValid = phoneNumberUtil.isValidNumber(phoneNumber);
        return isValid ? null : { invalidPhone: true, validatePhoneNumber: true };
    } catch (error) {
        return { invalidPhone: true, validatePhoneNumber: true };
    }
}
